import React from "react";
import PropTypes from "prop-types";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { ChoVayCombo } from "constants/choVayConst";
import ReactDropdown from "react-dropdown";
import SearchChoVay from "components/CommonComponent/SearchChoVay";
import { Dropdown } from "react-bootstrap";
import Pagination from "react-js-pagination";
import DongLaiContainer from "containers/Common/QuanLyChoVay/dongLai";
import CustomerDetail from "containers/Common/Customer/customerDetail";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { catChuoi } from "utils/stringExtension";
import { nFormatter } from "utils/currencyFormat";
import choVayConst from "constants/choVayConst";
import { startAndEndOfYear } from "utils/formatDate";
import { formatDayMonth, GetDateHomQua } from "utils/formatDate";
import { startAndEndOfMonth } from "utils/formatDate";
import { startAndEndOfWeek } from "utils/formatDate";
import GuiEmailContainer from "containers/Common/QuanLyChoVay/GuiEmailContainer";
import TinNhanContainer from "containers/Common/QuanLyChoVay/TinNhanContainer";
import XoaHopDongContainer from "containers/Common/QuanLyChoVay/XoaHopDongContainer";
import DoiTinhTrangNoContainer from "containers/Common/QuanLyChoVay/DoiTinhTrangNoContainer";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainerV2";
import InThuChiContainer from "containers/Common/ThuChi/InThuChiContainer";
import ButtonChuyenForm from "components/CommonComponent/ButtonChuyenForm";
import TatToanContainer from "containers/Common/QuanLyChoVay/TatToanContainer";
import { pushNotification } from "utils/notifications";
import { API_AUTH } from "service/common";
import configs from "constants/configs";
import InChoVay from "containers/Common/QuanLyChoVay/inChoVay";
import ThemMoiBanHangTraGop from "../../containers/BanHangTraGop/SubContainer/themMoiBanHangTraGop";
import { convertDate } from "utils/formatDate";
import DaoHoContainer from "containers/TraGop/SubContainer/daoHoContainer";
import { XuatExcelTraGop } from "../CommonComponent/XuatExcel/TraGop";
import { Cookies } from "react-cookie";
import ChiTietSoTienDaTraContainer from "containers/Common/QuanLyChoVay/ChiTietSoTienDaTraContainer";
import ChiTietTongSoTienDaTraContainer from "containers/Common/QuanLyChoVay/ChiTietTongSoTienDaTraContainer";
import { XuatExcelBanHangTraGop } from "./XuatExCel";
import BanHangTraGopApi from "service/banHangTraGopApi";
import configsRole from "utils/configsRole";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import cauHinh from "utils/cauHinh";
import CauHinhApi from "../../service/cauHinhApi";
import { ModelQRThanhToanHD } from "components/TichHopBank/ModelQRThanhToanHD";
import LayoutV2 from "containers/LayoutV2";
import { formatCurrency2 } from "utils/currencyFormat";

class BanHangTraGop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTKNangCao: false,
      showChiTietKhachHang: false,
      showChiTietHopDong: false,
      showTinNhanSMS: false,
      showGuiEmail: false,
      showXoa: false,
      showDoiTinhTrangNo: false,
      showThemMoiTraGop: false,
      showDaoHo: false,
      showGhiChu: false,
      dataSearch: {
        dateFrom: "01/01/2001",
        dateTo: "01/01/4000",
        code: "",
        customerName: "",
        address: "",
        noteTaiSan: "",
        status: "5",
        debt: "-1",
        userName: "",
        pageIndex: 1,
        pageSize: 20,
        ThoiGian: "",
        taiSan: 0,
        dongtungay: "01/01/2001",
        dongdenngay: "01/01/4000",
      },
      choVay: {},
      showDongLai: false,
      showXuatExcel3: false,
      showChiTietSoTienDaTra: false,
      showChiTietTongSoTienDaTra: false, //
      laiho_danhsachlaiho: false,
      laiho_themmoilaiho: false,
      laiho_sualaiho: false,
      laiho_xoalaiho: false,
      laiho_thanhtoan: false,
      laiho_tattoan: false,
      laiho_guiemail: false,
      laiho_nhantin: false,
      laiho_doitinhtranghopdong: false,
      laiho_thongtinchitiethopdong: false,
      laiho_thongtinchitietkhachhang: false,
      laiho_inhopdonglaiho: false,
      laiho_xuatexceldanhsachlaiho: false,
      tragop_thaydoitienlai: false,
      tragop_suatientattoan: false, //
      laiho_sudungchoduyet: false,
      chonngaygiaodich: false,
      thuchihopdong_xoaphieuthuchi: true,
      SuDungPhiPhat_DongLai_TatToan: false,
      isQRThanhToan: false,
      isShowModalQRThanhToanHD: false,
      itemDataQR: {},
      listTinhTrangNo: [
        {
          value: "-1",
          label: "Tất cả",
        },
      ],
    };
  }
  componentDidMount() {
    document.title = "Bán hàng trả góp | Phần mềm quản lý cầm đồ Morman";
    let { dataSearch } = this.state;
    let { getPhanQuyenTraGop, getComboUser, getConfig, getConfigSysTMTG } =
      this.props;
    getPhanQuyenTraGop();
    getComboUser();
    getConfig();
    getConfigSysTMTG();
    this.loadTraGop(dataSearch);
    //Code lấy tình trạng nợ
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      console.log(response, "aaaaaaaaaaaaaaaa11111");
      if (response.status === 200) {
        const dataComboTinhTrang = response.data.map((item) => ({
          value: item.Code,
          label: item.Name,
        }));
        const dataComboTinhTrangNew = [
          { value: "-1", label: "Tất cả" },
          ...dataComboTinhTrang,
        ];
        this.setState({ listTinhTrangNo: dataComboTinhTrangNew });
      }
    });
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const configIsQRThanhToan = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQRThanhToan.toUpperCase()
          );
          if (configIsQRThanhToan != null) {
            if (configIsQRThanhToan.valueConfig === "1") {
              this.setState({ isQRThanhToan: true });
            }
          }
        }
      }
    });
  }
  componentDidUpdate() {
    let { phanquyen, inthuchi } = this.props;
    let { showTatToan, dataSearch } = this.state;
    let { PhanQuyenTraGop } = phanquyen;
    let { inThuChiShow } = inthuchi;
    // let { laiho_danhsachlaiho } = PhanQuyenTraGop;
    // if (laiho_danhsachlaiho !== undefined && !laiho_danhsachlaiho) {
    //   window.location.href = configs.errorLink;
    // }
    if (showTatToan && inThuChiShow) {
      dataSearch.status = "2";
      this.setState({ showTatToan: false });
      this.loadTraGop(dataSearch);
    }
  }
  UNSAFE_componentWillReceiveProps(props) {
    this.loadQuyen();
  }
  loadQuyen() {
    //
    BanHangTraGopApi.getAllQuyen().then((response) => {
      if (response.status === 200) {
        var sRoleDanhSach = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_danhsach.toUpperCase()
        );
        if (sRoleDanhSach != null) {
          this.setState({
            laiho_danhsachlaiho: true,
          });
        } else {
          window.location.href = configs.errorLink;
          this.setState({
            laiho_danhsachlaiho: false,
          });
        }
        var sRoleThemMoi = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_themmoi.toUpperCase()
        );
        if (sRoleThemMoi != null) {
          this.setState({
            laiho_themmoilaiho: true,
          });
        } else {
          this.setState({
            laiho_themmoilaiho: false,
          });
        }
        var sRoleSua = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_sua.toUpperCase()
        );
        if (sRoleSua != null) {
          this.setState({
            laiho_sualaiho: true,
          });
        } else {
          this.setState({
            laiho_sualaiho: false,
          });
        }

        var sRoleXoa = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_xoa.toUpperCase()
        );
        if (sRoleXoa != null) {
          this.setState({
            laiho_xoalaiho: true,
          });
        } else {
          this.setState({
            laiho_xoalaiho: false,
          });
        }

        var sRoleThanhToan = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_thanhtoan.toUpperCase()
        );
        if (sRoleThanhToan != null) {
          this.setState({
            laiho_thanhtoan: true,
          });
        } else {
          this.setState({
            laiho_thanhtoan: false,
          });
        }

        var sRoleTatToan = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_tattoan.toUpperCase()
        );
        if (sRoleTatToan != null) {
          this.setState({
            laiho_tattoan: true,
          });
        } else {
          this.setState({
            laiho_tattoan: false,
          });
        }

        var sRoleEmail = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_guiemail.toUpperCase()
        );
        if (sRoleEmail != null) {
          this.setState({
            laiho_guiemail: true,
          });
        } else {
          this.setState({
            laiho_guiemail: false,
          });
        }

        var sRoleNhanTin = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_nhantin.toUpperCase()
        );
        if (sRoleNhanTin != null) {
          this.setState({
            laiho_nhantin: true,
          });
        } else {
          this.setState({
            laiho_nhantin: false,
          });
        }

        var sRoleDoiTinhTrang = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_doitinhtranghopdong.toUpperCase()
        );
        if (sRoleDoiTinhTrang != null) {
          this.setState({
            laiho_doitinhtranghopdong: true,
          });
        } else {
          this.setState({
            laiho_doitinhtranghopdong: false,
          });
        }

        var sRoleChiTietHD = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_thongtinchitiethopdong.toUpperCase()
        );
        if (sRoleChiTietHD != null) {
          this.setState({
            laiho_thongtinchitiethopdong: true,
          });
        } else {
          this.setState({
            laiho_thongtinchitiethopdong: false,
          });
        }

        var sRoleChiTietKH = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_thongtinchitietkhachhang.toUpperCase()
        );
        if (sRoleChiTietKH != null) {
          this.setState({
            laiho_thongtinchitietkhachhang: true,
          });
        } else {
          this.setState({
            laiho_thongtinchitietkhachhang: false,
          });
        }

        var sRoleInHD = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_inhopdong.toUpperCase()
        );
        if (sRoleInHD != null) {
          this.setState({
            laiho_inhopdonglaiho: true,
          });
        } else {
          this.setState({
            laiho_inhopdonglaiho: false,
          });
        }

        var sRoleXuatExcel = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_xuatexceldanhsach.toUpperCase()
        );
        if (sRoleXuatExcel != null) {
          this.setState({
            laiho_xuatexceldanhsachlaiho: true,
          });
        } else {
          this.setState({
            laiho_xuatexceldanhsachlaiho: false,
          });
        }

        var sRoleThayDoiLai = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_thaydoitienlai.toUpperCase()
        );
        if (sRoleThayDoiLai != null) {
          this.setState({
            tragop_thaydoitienlai: true,
          });
        } else {
          this.setState({
            tragop_thaydoitienlai: false,
          });
        }

        var sRoleSuaTienTT = response.data.find(
          (e) =>
            e.ModuleCode.toUpperCase() ===
            configsRole.sRole.banhangtragop_suatientattoan.toUpperCase()
        );
        if (sRoleSuaTienTT != null) {
          this.setState({
            tragop_suatientattoan: true,
          });
        } else {
          this.setState({
            tragop_suatientattoan: false,
          });
        }

        //
      }
    });
  }
  loadTraGop(dataSearch) {
    let { getListTraGop } = this.props;
    getListTraGop(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  setTKNangCaoModalShow = (dataSearch) => {
    this.setState({ showTKNangCao: !this.state.showTKNangCao });
    if (dataSearch && this.state.showTKNangCao) {
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };
  setModalChiTietKhachHangShow = (choVay) => () => {
    let { showChiTietKhachHang } = this.state;
    if (choVay)
      this.setState({ showChiTietKhachHang: !showChiTietKhachHang, choVay });
    else this.setState({ showChiTietKhachHang: !showChiTietKhachHang });
    if (showChiTietKhachHang) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };
  setModalChiTietHopDongShow = (choVay) => () => {
    let { showChiTietHopDong } = this.state;
    if (choVay)
      this.setState({ showChiTietHopDong: !showChiTietHopDong, choVay });
    else this.setState({ showChiTietHopDong: !showChiTietHopDong });
    if (showChiTietHopDong) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };

  setModalTinNhanSMSShow = (choVay) => () => {
    let { showTinNhanSMS } = this.state;
    if (choVay) this.setState({ showTinNhanSMS: !showTinNhanSMS, choVay });
    else this.setState({ showTinNhanSMS: !showTinNhanSMS });
    if (showTinNhanSMS) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };

  setModalGuiEmailShow = (choVay) => () => {
    let { showGuiEmail } = this.state;
    if (choVay) this.setState({ showGuiEmail: !showGuiEmail, choVay });
    else this.setState({ showGuiEmail: !showGuiEmail });
    if (showGuiEmail) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };

  setModalXoaShow = (choVay) => () => {
    let { showXoa } = this.state;
    if (choVay) this.setState({ showXoa: !showXoa, choVay });
    else this.setState({ showXoa: !showXoa });
    if (showXoa) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };

  setModalDoiTinhTrangNoShow = (choVay) => () => {
    let { showDoiTinhTrangNo } = this.state;
    if (choVay)
      this.setState({ showDoiTinhTrangNo: !showDoiTinhTrangNo, choVay });
    else this.setState({ showDoiTinhTrangNo: !showDoiTinhTrangNo });
    if (showDoiTinhTrangNo) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };
  setDongLaiModalShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    if (data)
      this.setState({
        showDongLai: !this.state.showDongLai,
        choVay: data,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showVayThem: false,
        showTatToan: false,
      });
    else this.setState({ showDongLai: !this.state.showDongLai });
    if (this.state.showDongLai) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };
  setModalTatToanShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showTatToan } = this.state;
    if (data)
      this.setState({
        showTatToan: !showTatToan,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showVayThem: false,
      });
    else this.setState({ showTatToan: !showTatToan });
    if (showTatToan) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };
  setModalTraGopShow = (chovay) => () => {
    let { showFormTraGop, themmoitragop } = this.props;
    let choVayEdit = null;
    if (chovay) {
      choVayEdit = { ...chovay };
      if (choVayEdit.kyLai && parseFloat(choVayEdit.kyLai) > 0)
        choVayEdit.CountTypePaid = choVayEdit.kyLai;
      choVayEdit.NgayVay = convertDate(chovay.NgayVay);
      choVayEdit.NgayThanhToan = convertDate(chovay.DatePaid);
    }
    this.setState({
      choVayEdit,
    });
    let { isShowFormTraGop } = themmoitragop;
    this.props.themmoitragop.postTraGopReturn = false;
    this.props.themmoitragop.TaiSanTraGop.AnhTaiSan = "";
    if (isShowFormTraGop) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
    showFormTraGop(choVayEdit);
  };
  setIsTraGopReturn = () => {
    this.props.themmoitragop.postTraGopReturn = false;
  };
  setModalDaoHoShow = (data) => () => {
    let { showFormDaoHo } = this.props;
    showFormDaoHo(data);
  };
  setInChoVayModalShow = () => () => {
    let { showInChoVay, choVay } = this.state;
    if (choVay && !choVay.ChoVayId) {
      pushNotification("Hãy chọn hợp đồng", "warning", "TOP_CENTER", 1000);
      return;
    }
    this.setState({ showInChoVay: !showInChoVay });
  };
  setInChoVayModalShowTM = (choVay) => () => {
    let { showInChoVay } = this.state;
    if (choVay && !choVay.ChoVayId) {
      pushNotification("Hãy chọn hợp đồng", "warning", "TOP_CENTER", 1000);
      return;
    }
    this.setState({ choVay });
    this.setState({ showInChoVay: !showInChoVay });
  };
  setInThuChiModalShow = (thuChiId) => () => {
    let { showInPhieuThuChi } = this.props;
    showInPhieuThuChi(thuChiId);
  };
  xuatExcel = () => () => {
    let { dataSearch } = this.state;
    let {
      dateFrom,
      dateTo,
      code,
      customerName,
      address,
      noteTaiSan,
      status,
      debt,
      userName,
      dongtungay,
      dongdenngay,
    } = dataSearch;
    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }
    link =
      link +
      `quanlychovay/tra-gop-xuat-excel?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}`;
    API_AUTH.get(link).then((res) => {
      var uri = "data:application/vnd.ms-excel," + encodeURIComponent(res.data);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download = "DanhSachTrGop.xls";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };
  selectRow = (item) => () => {
    this.setState({ choVay: item });
  };

  xuatExcel3 = () => () => {
    let { showXuatExcel3 } = this.state;
    showXuatExcel3 = true;
    this.setState({ showXuatExcel3 });
  };

  hideXuatExcel = () => () => {
    let { showXuatExcel3 } = this.state;
    showXuatExcel3 = false;
    this.setState({ showXuatExcel3 });
  };

  setModalChiTietTienDaTraShow = (choVay) => () => {
    let { showChiTietSoTienDaTra } = this.state;
    if (choVay)
      this.setState({
        showChiTietSoTienDaTra: !showChiTietSoTienDaTra,
        choVay,
      });
    else this.setState({ showChiTietSoTienDaTra: !showChiTietSoTienDaTra });
  };

  setModalChiTietTongTienDaTraShow = () => () => {
    let { showChiTietTongSoTienDaTra } = this.state;
    this.setState({ showChiTietTongSoTienDaTra: !showChiTietTongSoTienDaTra });
  };

  renderTableRows() {
    let {
      tragop,
      phanquyen,
      showXoaHopDong,
      showModalGuiEmail,
      showModalGuiTinNhan,
    } = this.props;
    let { PhanQuyenTraGop } = phanquyen;
    let {
      laiho_doitinhtranghopdong,
      laiho_thanhtoan,
      laiho_sualaiho,
      laiho_guiemail,
      laiho_nhantin,
      laiho_tattoan,
      laiho_thongtinchitiethopdong,
      laiho_thongtinchitietkhachhang,
      laiho_xoalaiho,
      laiho_daoho,
      tragop_suatientattoan,
    } = this.state;
    let { choVay, isQRThanhToan } = this.state;
    return tragop.objList.List.map((item, index) => (
      <div
        className={"custom-table-row " + (item === choVay && "active")}
        key={"item" + index}
        onClick={this.selectRow(item)}
      >
        {item.DebtLevel === 2 && (
          <span className="line-job-color job-color-picker-1"></span>
        )}
        {item.DebtLevel === 3 && (
          <span className="line-job-color job-color-picker-2"></span>
        )}
        <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
          <span className="mobile-column-name">STT</span>
          <div className="center-wrapper">
            <p className="text-center">{item.IndexId}</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-16 flex-basis-15-6-sm">
          <span className="mobile-column-name">Mã hợp đồng</span>
          <div className="center-wrapper">
            <span className="profile_name">
              {laiho_thongtinchitiethopdong ? (
                <a
                  id=""
                  href={() => false}
                  className="blue btn-link"
                  onClick={this.setModalChiTietHopDongShow(item)}
                >
                  {item.Code}
                </a>
              ) : (
                item.Code
              )}
            </span>
            <span className="font-lai">
              <br />
              {getDate(item.NgayVay)}
              <br />
              {getDate(item.NgayTra)}
            </span>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-12 flex-basis-11-8-sm">
          <span className="mobile-column-name">Tên khách hàng</span>
          <div className="center-wrapper">
            {laiho_thongtinchitietkhachhang ? (
              <a
                id=""
                href={() => false}
                className="blue btn-link"
                onClick={this.setModalChiTietKhachHangShow(item)}
              >
                <span title={item.CustomerName}> {item.CustomerName} </span>
              </a>
            ) : (
              <span title={item.CustomerName}> {item.CustomerName} </span>
            )}

            <br />
            {item.phoneCus && (
              <span title={item.phoneCus} className="font-lai color7">
                {" "}
                {catChuoi(item.phoneCus, 10)}
              </span>
            )}
          </div>
        </div>

        <div className="custom-table-cell flex-basis-8 flex-basis-6-sm">
          <span className="mobile-column-name">TS thế chấp</span>
          <div className="center-wrapper">
            <p className="text-ds" title={item.TaiSan}>
              {catChuoi(item.TaiSan, 10)}
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-8 flex-basis-6-sm">
          <span className="mobile-column-name">TS trả góp</span>
          <div className="center-wrapper">
            <p className="text-ds" title={item.TenSanPham}>
              {item.TenSanPham}
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
          <span className="mobile-column-name">Tổng tiền cần thu</span>
          <div className="center-wrapper">
            <p className="text-right">
              <span
                className="fontnew-500 color-do-bold"
                title={formatNumber(item.SoTienVayConLai)}
              >
                {formatCurrency2(item.SoTienVayConLai)}
              </span>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
          <span className="mobile-column-name">Số tiền đã trả</span>
          <div className="center-wrapper">
            <p className="text-right">
              {" "}
              <a
                id=""
                href={() => false}
                className="blue btn-link"
                onClick={this.setModalChiTietTienDaTraShow(item)}
              >
                {formatNumber(
                  item.TC_ValueGoc +
                    item.TC_ValueLai +
                    item.TC_PhiKho +
                    item.TC_OtheFeeHangKy +
                    item.TC_Amercement +
                    item.TC_OtherFee +
                    item.TC_PhiPhatDongLai +
                    item.TC_PhiHoaHongTraGop +
                    item.TC_PhiPhatTatToan
                )}
                {/* {formatNumber(item.Paided)} */}
              </a>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
          <span className="mobile-column-name">Còn phải đóng</span>
          <div className="center-wrapper">
            <p className="text-right">
              <span className="color-cam-bold">
                {formatNumber(item.ValuePaid - item.Paided)}
              </span>
              <br />
              {item.SoLanPhaiDong > 0 && <p>({item.SoLanPhaiDong} kỳ)</p>}
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-10 flex-basis-6-sm">
          <span className="mobile-column-name">Trạng thái</span>
          <div className="center-wrapper">
            <p className="text-center">
              <span
                className={
                  item.Status === 4
                    ? "canh-bao-red-v2"
                    : item.Status === 3
                    ? "canh-bao-no"
                    : item.Status === 2
                    ? "dong"
                    : "dang-vay"
                }
              >
                {choVayConst.StatusHoText[item.Status]}
              </span>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-16 flex-basis-15-6-sm  reponsive-cell-v2">
          <div className="center-wrapper">
            {item.Status !== 2 && (
              <div className="iconTableMorman">
                {laiho_sualaiho && (
                  <a href={() => false} onClick={this.setModalTraGopShow(item)}>
                    <PopoversBootrap
                      contentText="Sửa"
                      titleText=""
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <img src="/app-assets/images/icon-edit-v2.png" />
                    </PopoversBootrap>
                  </a>
                )}
                {laiho_thanhtoan && (
                  <a
                    onClick={this.setDongLaiModalShow(item)}
                    href={() => false}
                  >
                    <PopoversBootrap
                      contentText="Đóng lãi"
                      titleText=""
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <span className="dong-lai-button"></span>
                    </PopoversBootrap>
                  </a>
                )}

                {laiho_tattoan && (
                  <a
                    href={() => false}
                    onClick={this.setModalTatToanShow(item)}
                  >
                    <PopoversBootrap
                      contentText="Tất toán"
                      titleText=""
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <span className="tat-toan-button"></span>
                    </PopoversBootrap>
                  </a>
                )}
                <Dropdown className="DropNew trangthai-new dropdown-toggle">
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <img
                      src="/app-assets/images/icon-more.png"
                      alt="Dropdown icon"
                      className="dropdown-icon"
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="dropdown-menu-v2 arrow"
                    style={{ borderRadius: "10px" }}
                  >
                    <div className="block-iconmm  vertical-layout">
                      {laiho_nhantin && (
                        <a
                          className="dropdown-item"
                          href={() => false}
                          onClick={showModalGuiTinNhan}
                        >
                          <PopoversBootrap
                            contentText="Nhắn tin"
                            titleText=""
                            trigger={["hover", "focus"]}
                            placement={"top"}
                          >
                            <img src="/app-assets/images/icon-tin-nhan.png" />
                          </PopoversBootrap>
                          <span class="vertical-align-v2">Gửi tin nhắn</span>
                        </a>
                      )}

                      {laiho_guiemail && (
                        <a
                          className="dropdown-item"
                          href={() => false}
                          onClick={showModalGuiEmail}
                        >
                          <PopoversBootrap
                            contentText="Gửi Email"
                            titleText=""
                            trigger={["hover", "focus"]}
                            placement={"top"}
                          >
                            <img src="/app-assets/images/icon-gui-mail.png" />
                          </PopoversBootrap>
                          <span class="vertical-align-v2">Gửi Email</span>
                        </a>
                      )}

                      {laiho_doitinhtranghopdong && (
                        <a
                          className="dropdown-item"
                          href={() => false}
                          onClick={this.setModalDoiTinhTrangNoShow(item)}
                        >
                          <PopoversBootrap
                            contentText="Đổi tình trạng nợ"
                            titleText=""
                            trigger={["hover", "focus"]}
                            placement={"top"}
                          >
                            <img src="/app-assets/images/icon-doi-tinh-trang-no.png" />
                          </PopoversBootrap>
                          <span class="vertical-align-v2">
                            Đổi tình trạng nợ
                          </span>
                        </a>
                      )}
                      {isQRThanhToan && (
                        <a
                          className="dropdown-item"
                          onClick={this.setModalQRThanhToanShow(item)}
                          href={() => false}
                        >
                          <PopoversBootrap
                            contentText="QR thanh toán"
                            titleText=""
                            trigger={["hover", "focus"]}
                            placement={"top"}
                          >
                            <img src="/app-assets/images/icon-qrcode-v2.png" />
                          </PopoversBootrap>
                          <span class="vertical-align-v2">QR code</span>
                        </a>
                      )}
                      {laiho_xoalaiho && (
                        <a
                          className="dropdown-item"
                          href={() => false}
                          onClick={showXoaHopDong}
                        >
                          <PopoversBootrap
                            contentText="Xoá"
                            titleText=""
                            trigger={["hover", "focus"]}
                            placement={"top"}
                          >
                            <img
                              style={{ marginLeft: "5px" }}
                              src="/app-assets/images/icon-xoa-v2.png"
                            />
                          </PopoversBootrap>
                          <span
                            class="vertical-align-v2"
                            style={{ color: "#FF5170", marginLeft: "10px" }}
                          >
                            Xóa
                          </span>
                        </a>
                      )}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
          </div>
        </div>
      </div>
    ));
  }
  setModalGhiChuShow = (choVay) => () => {
    let { showGhiChu } = this.state;
    if (choVay) this.setState({ showGhiChu: !showGhiChu, choVay });
    else this.setState({ showGhiChu: !showGhiChu });
    if (showGhiChu) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };
  handlePageChange = (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadTraGop(dataSearch);
  };
  _onSelect = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    this.setState({ dataSearch });
  };
  _onSelectDate = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    dataSearch.dateFrom = "01/01/2001";
    dataSearch.dateTo = "01/01/4001";
    if (value.value === "1") {
      dataSearch.dateFrom = formatDayMonth(new Date());
      dataSearch.dateTo = formatDayMonth(new Date());
    }
    if (value.value === "2") {
      var date2s = startAndEndOfWeek(new Date());
      dataSearch.dateFrom = formatDayMonth(date2s[0]);
      dataSearch.dateTo = formatDayMonth(date2s[1]);
    }
    if (value.value === "3") {
      var date1s = startAndEndOfMonth(new Date());
      dataSearch.dateFrom = formatDayMonth(date1s[0]);
      dataSearch.dateTo = formatDayMonth(date1s[1]);
    }
    if (value.value === "4") {
      var date4s = startAndEndOfYear(new Date());
      dataSearch.dateFrom = formatDayMonth(date4s[0]);
      dataSearch.dateTo = formatDayMonth(date4s[1]);
    }
    // Hôm qua
    if (value.value === "5") {
      dataSearch.dateFrom = GetDateHomQua();
      dataSearch.dateTo = GetDateHomQua();
    }
    this.setState({ dataSearch });
  };
  onChangeData = (field) => (event) => {
    let { dataSearch } = this.state;
    dataSearch[field] = event.target.value;
    this.setState({ dataSearch });
  };
  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };
  onSearch = () => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadTraGop(dataSearch);
  };
  getListData = () => () => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadTraGop(dataSearch);
  };
  toggleModalQRThanhToanHD() {
    this.setState({
      isShowModalQRThanhToanHD: !this.state.isShowModalQRThanhToanHD,
    });
  }
  setModalQRThanhToanShow = (hopdong) => () => {
    this.setState({ itemDataQR: hopdong });
    this.toggleModalQRThanhToanHD();
  };
  render() {
    let {
      dataSearch,
      showTKNangCao,
      showChiTietKhachHang,
      showChiTietHopDong,
      showDoiTinhTrangNo,
      choVay,
      showTatToan,
      showDongLai,
      showInChoVay,
      showXuatExcel3,
      showChiTietSoTienDaTra,
      showChiTietTongSoTienDaTra,
    } = this.state;
    let { user, tragop, phanquyen, inthuchi, themmoitragop } = this.props;
    let {
      TotalMoney,
      TotalPaid,
      TotalPaidToDateNow,
      TotalQuantity,
      TT_Amercement,
      TT_OtheFeeHangKy,
      TT_OtherFee,
      TT_PhiHoaHongTraGop,
      TT_PhiKho,
      TT_PhiPhatDongLai,
      TT_ValueGoc,
      TT_ValueLai,
      TT_PhiPhatTatToan,
    } = tragop.objList;
    let { PhanQuyenTraGop } = phanquyen;

    console.log("Phan quyen", PhanQuyenTraGop);

    let {
      // laiho_inhopdonglaiho,
      // laiho_themmoilaiho,
      // laiho_xuatexceldanhsachlaiho,
      // tragop_thaydoitienlai,
      chonngaygiaodich,
      // thuchihopdong_suaphieuthuchi,
      // thuchihopdong_xoaphieuthuchi,
      // laiho_tattoan,
      // laiho_thanhtoan,
      // tragop_suatientattoan,
      SuDungPhiPhat_DongLai_TatToan,
    } = PhanQuyenTraGop;
    let {
      laiho_inhopdonglaiho,
      laiho_themmoilaiho,
      laiho_xuatexceldanhsachlaiho,
      //  chonngaygiaodich,
      tragop_thaydoitienlai,
      thuchihopdong_suaphieuthuchi,
      thuchihopdong_xoaphieuthuchi,
      laiho_tattoan,
      laiho_thanhtoan,
      tragop_suatientattoan,
      //  SuDungPhiPhat_DongLai_TatToan,
    } = this.state;
    let { inThuChiShow } = inthuchi;
    let { getListTraGopLoading } = tragop;
    let { isShowFormTraGop, ConfigTMTG } = themmoitragop;
    let { HoaHongTraGop } = ConfigTMTG;
    let soTienDaTra =
      TT_Amercement +
      TT_OtheFeeHangKy +
      TT_OtherFee +
      TT_PhiHoaHongTraGop +
      TT_PhiKho +
      TT_PhiPhatDongLai +
      TT_ValueGoc +
      TT_ValueLai +
      TT_PhiPhatTatToan;
    return (
      <LayoutV2>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="laiho-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Bán hàng trả góp</h1>
                        </div>
                      </div>
                      <div className="bg-right-breacrumb hidden-mobile-main">
                        {/* <div className="btn-group btn-light-v2">
                          <ul>
                            <li>
                              {laiho_inhopdonglaiho && (
                                <a
                                  href={() => false}
                                  className="icon-bgnew color-print1"
                                  onClick={this.setInChoVayModalShow()}
                                >
                                  <img src="/app-assets/images/logo-print-v2.png" />
                                </a>
                              )}
                            </li>
                            <li>
                              {laiho_xuatexceldanhsachlaiho && (
                                <a
                                  href={() => false}
                                  className="icon-bgnew color-print1"
                                  onClick={this.xuatExcel()}
                                >
                                  <img src="/app-assets/images/icon-tai-xuong-v2.png" />
                                </a>
                              )}
                            </li>
                            <li>
                              {laiho_xuatexceldanhsachlaiho && (
                                <a
                                  href={() => false}
                                  className="icon-bgnew color-print1"
                                  onClick={this.xuatExcel3()}
                                >
                                  <img src="/app-assets/images/icon-tai-xuong-v2.png" />
                                </a>
                              )}
                            </li>
                          </ul>
                        </div> */}
                      </div>
                      <div className="hide-table-main show-mobile-main hidden-des-main">
                        {laiho_themmoilaiho && (
                          <div>
                            <button
                              type="button"
                              className="btn btn-border-new"
                              onClick={this.setModalTraGopShow()}
                              style={{ margin: "0px" }}
                            >
                              <i className="mdi mdi-plus"></i> Thêm mới
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                  <div data-repeater-list="car">
                    <div
                      data-repeater-item
                      className="form row bg-search-form form-mobile-search"
                    >
                      <div
                        className="text-right  search-p mb-1 "
                        style={{ width: "100%" }}
                      >
                        <div className="form-search-mobile-new">
                          <div className="left-search-mobile-new">
                            <div className="search-mobile-new">
                              <fieldset className="form-group position-relative mb-0">
                                <input
                                  type="text"
                                  className="form-control input-sm"
                                  placeholder="Tên, mã, sđt khách hàng ..."
                                  onChange={this.onChangeData("customerName")}
                                  onKeyDown={this.handleKeyDown}
                                  value={dataSearch.customerName}
                                />
                                <div
                                  className="form-control-position"
                                  onClick={this.onSearch}
                                >
                                  <i className="mdi mdi-magnify"></i>
                                </div>
                              </fieldset>
                            </div>
                          </div>
                          <div className="right-search-mobile-new">
                            <div class="icon-search-mobile">
                              <a
                                href={() => false}
                                className="card-link blue darken-2 text-search-new"
                                onClick={this.setTKNangCaoModalShow}
                              >
                                <i className="mdi mdi-filter"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card border-light mb-3 mt-1 hidden-mobile-main show-table-main card-v2"
                  style={{ marginTop: "-8px" }}
                >
                  <div className="card-body card-body-v2">
                    <div className="search-new">
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Tìm kiếm
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Tên, sđt khách hàng"
                          onChange={this.onChangeData("customerName")}
                          onKeyDown={this.handleKeyDown}
                          value={dataSearch.customerName}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Trạng thái
                        </label>
                        <ReactDropdown
                          onChange={this._onSelect("status")}
                          options={ChoVayCombo.StatusComboLaiHo}
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                          arrowClassName=""
                          value={dataSearch.status}
                        />
                      </div>

                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Tình trạng
                        </label>
                        <ReactDropdown
                          onChange={this._onSelect("debt")}
                          // options={ChoVayCombo.TinhTrangCombo}
                          options={this.state.listTinhTrangNo}
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                          value={dataSearch.debt}
                        />
                      </div>

                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Thời gian
                        </label>
                        <ReactDropdown
                          onChange={this._onSelectDate("ThoiGian")}
                          options={ChoVayCombo.ThoiGianCombo}
                          value={ChoVayCombo.ThoiGianDefault}
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                        />
                      </div>
                      <div className="input-sm-new input-new-18 search-main-new">
                        <label className="font-color-default font-bold">
                          &nbsp;
                        </label>
                        <button
                          type="submit"
                          className="btn btn-info-new "
                          onClick={this.onSearch}
                        >
                          <i className="la la-search"></i>
                          <span> &nbsp; Tìm kiếm</span>
                        </button>
                      </div>
                      <div className="input-sm-new input-new-5 search-main-new">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          &nbsp;
                        </label>
                        <a
                          href={() => false}
                          className="card-link blue darken-2 text-search-new filter-search"
                          onClick={this.setTKNangCaoModalShow}
                        >
                          <i>
                            <PopoversBootrap
                              contentText="Tìm kiếm nâng cao"
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img
                                className="icon-bred-home"
                                src="/app-assets/images/icon-fitter-v2.png"
                                alt=""
                                style={{ scale: "0.9", verticalAlign: "sub" }}
                              />
                            </PopoversBootrap>
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card border-light mb-1 card-v2"
                  style={{
                    marginTop: "-35px",
                  }}
                >
                  <div className="card-body card-body-v2">
                    <div className="row col-sm-12 col-md-12 themoi-taisanthanhly hidden-mobile-main">
                      <div className="col-sm-12 col-md-10">
                        {laiho_themmoilaiho && (
                          <button
                            type="button"
                            className="btn btn-border-new"
                            onClick={this.setModalTraGopShow()}
                          >
                            <i className="mdi mdi-plus"></i> Thêm mới
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="Left808x200 Table-main-new  css-table-ds">
                      <div
                        className="loading-page1"
                        style={{ zIndex: "999999999999999999 !important" }}
                      >
                        <div
                          className={
                            "loader loader-default " +
                            (getListTraGopLoading ? "is-active" : "")
                          }
                        ></div>
                      </div>
                      <div className="table-mobile  table-mobile-hover">
                        <div className="custom-table-wrapper">
                          <div className="table-headers">
                            <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                              <p className="text-center">
                                STT
                                <br />{" "}
                                <span className="color-do-bold">
                                  [{TotalQuantity}]
                                </span>
                              </p>
                            </div>
                            <div className="custom-table-header flex-basis-16 flex-basis-15-6-sm">
                              <p>Mã hợp đồng</p>
                            </div>
                            <div className="custom-table-header flex-basis-12 flex-basis-11-8-sm">
                              <p>Tên khách hàng</p>
                            </div>
                            <div className="custom-table-header flex-basis-8 flex-basis-6-sm">
                              <p className="text-ds">TS thế chấp</p>
                            </div>
                            <div className="custom-table-header flex-basis-8 flex-basis-6-sm">
                              <p className="text-ds">TS trả góp</p>
                            </div>
                            <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                              <p className="text-right">
                                Tổng tiền cần thu
                                <br />
                                <span
                                  className="color-do-bold"
                                  title={formatNumber(TotalMoney)}
                                >
                                  {formatCurrency2(TotalMoney)}
                                </span>
                              </p>
                            </div>
                            <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                              <p className="text-right">
                                Số tiền đã trả
                                <br />
                                <span className="color-xanh-bold">
                                  <a
                                    id=""
                                    href={() => false}
                                    onClick={this.setModalChiTietTongTienDaTraShow()}
                                    title={formatNumber(soTienDaTra)}
                                  >
                                    {formatCurrency2(soTienDaTra)}
                                  </a>
                                </span>
                              </p>
                            </div>
                            <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                              <p className="text-right">
                                Còn phải đóng <br />
                                <span
                                  className="color-cam-bold"
                                  title={formatNumber(TotalPaidToDateNow)}
                                >
                                  {formatCurrency2(TotalPaidToDateNow)}
                                </span>
                              </p>
                            </div>
                            <div className="custom-table-header flex-basis-10 flex-basis-6-sm">
                              <p className="tab-header text-center">
                                Trạng thái
                              </p>
                            </div>
                            <div className="custom-table-header flex-basis-16 flex-basis-15-6-sm action-cell">
                              <p className="tab-header">Chức năng</p>
                            </div>
                          </div>

                          <div className="custom-table-body">
                            {this.renderTableRows()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-3 card-v2 card-footer-v2">
                  <div className="card-body card-body-v2">
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        <span className="color7">
                          {TotalQuantity === 0 ? (
                            "Hiển thị 0 - 0 / Tổng số 0"
                          ) : (
                            <>
                              Hiển thị{" "}
                              {(dataSearch.pageIndex - 1) *
                                dataSearch.pageSize +
                                1}{" "}
                              -{" "}
                              {Math.min(
                                dataSearch.pageIndex * dataSearch.pageSize,
                                TotalQuantity
                              )}{" "}
                              / Tổng số {TotalQuantity}
                            </>
                          )}
                        </span>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div
                          className={
                            "paniation-new paniation-new1 d-flex justify-content-center " +
                            (TotalQuantity === 0 ? "hidden" : "")
                          }
                          style={{ float: "right" }}
                        >
                          <nav aria-label="Page navigation">
                            <Pagination
                              activePage={dataSearch.pageIndex}
                              itemsCountPerPage={dataSearch.pageSize}
                              totalItemsCount={TotalQuantity}
                              pageRangeDisplayed={5}
                              onChange={this.handlePageChange}
                              itemClass="page-item border-none"
                              linkClass="page-link border-none"
                              activeClass="active"
                            />
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isShowFormTraGop && (
          <ThemMoiBanHangTraGop
            show={isShowFormTraGop}
            onHide={this.setModalTraGopShow(null)}
            inPhieuThu={this.setInThuChiModalShow}
            inHopDong={this.setInChoVayModalShowTM}
            phanquyen={PhanQuyenTraGop}
            setIsTraGopReturn={this.setIsTraGopReturn}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
          ></ThemMoiBanHangTraGop>
        )}

        {showChiTietKhachHang && (
          <CustomerDetail
            onHide={this.setModalChiTietKhachHangShow(choVay)}
            show={showChiTietKhachHang && !showChiTietHopDong}
            showChiTietHopDong={this.setModalChiTietHopDongShow}
            data={choVay}
          ></CustomerDetail>
        )}

        {showDongLai && (
          <DongLaiContainer
            show={showDongLai && !inThuChiShow}
            onHide={this.setDongLaiModalShow(choVay)}
            onShowPhieuThu={this.setInThuChiModalShow}
            data={choVay}
            thaydoitienlai={tragop_thaydoitienlai}
            chonngaygiaodich={chonngaygiaodich}
            xoaphieuthuchi={thuchihopdong_xoaphieuthuchi}
            showPhiPhat={HoaHongTraGop === 1}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            buttonLeft={
              <ButtonChuyenForm
                // showDongLai={this.setDongLaiModalShow(choVay)}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={laiho_tattoan}
              ></ButtonChuyenForm>
            }
          ></DongLaiContainer>
        )}

        {showTatToan && (
          <TatToanContainer
            show={showTatToan && !inThuChiShow}
            data={choVay}
            onHide={this.setModalTatToanShow(choVay)}
            chonngaygiaodich={chonngaygiaodich}
            quyenSuaTienTatToan={tragop_suatientattoan}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={laiho_thanhtoan}
              ></ButtonChuyenForm>
            }
          ></TatToanContainer>
        )}
        {showInChoVay && (
          <InChoVay
            data={choVay}
            show={showInChoVay}
            onHide={this.setInChoVayModalShow()}
          ></InChoVay>
        )}

        {inThuChiShow && (
          <InThuChiContainer
            show={inThuChiShow}
            onHide={this.setInThuChiModalShow()}
          ></InThuChiContainer>
        )}
        {showChiTietHopDong && (
          <ChiTietHopDongContainer
            show={showChiTietHopDong}
            onHide={this.setModalChiTietHopDongShow(choVay)}
            data={choVay}
          ></ChiTietHopDongContainer>
        )}
        {showDoiTinhTrangNo && (
          <DoiTinhTrangNoContainer
            show={showDoiTinhTrangNo}
            onHide={this.setModalDoiTinhTrangNoShow(choVay)}
            data={choVay}
          ></DoiTinhTrangNoContainer>
        )}

        <XoaHopDongContainer
          data={choVay}
          getList={this.getListData()}
        ></XoaHopDongContainer>

        <GuiEmailContainer data={choVay}></GuiEmailContainer>
        <TinNhanContainer data={choVay}></TinNhanContainer>
        <SearchChoVay
          data={dataSearch}
          show={showTKNangCao}
          onHide={this.setTKNangCaoModalShow}
          userCombo={user.combo}
          trangs={"TraGop"}
          listTinhTrangNo={this.state.listTinhTrangNo}
        ></SearchChoVay>
        {showXuatExcel3 && (
          <XuatExcelBanHangTraGop
            dataSearch={dataSearch}
            show={showXuatExcel3}
            onHide={this.hideXuatExcel()}
          />
        )}

        {/* <XuatExcelTraGop
          dataSearch={dataSearch}
          show={showXuatExcel3}
          onHide={this.hideXuatExcel()}
        ></XuatExcelTraGop> */}

        {showChiTietSoTienDaTra && (
          <ChiTietSoTienDaTraContainer
            show={showChiTietSoTienDaTra}
            onHide={this.setModalChiTietTienDaTraShow(choVay)}
            data={choVay}
          ></ChiTietSoTienDaTraContainer>
        )}
        {showChiTietTongSoTienDaTra && (
          <ChiTietTongSoTienDaTraContainer
            show={showChiTietTongSoTienDaTra}
            onHide={this.setModalChiTietTongTienDaTraShow()}
            TT_Amercement={TT_Amercement}
            TT_OtheFeeHangKy={TT_OtheFeeHangKy}
            TT_OtherFee={TT_OtherFee}
            TT_PhiHoaHongTraGop={TT_PhiHoaHongTraGop}
            TT_PhiKho={TT_PhiKho}
            TT_PhiPhatDongLai={TT_PhiPhatDongLai}
            TT_ValueGoc={TT_ValueGoc}
            TT_ValueLai={TT_ValueLai}
            TT_PhiPhatTatToan={TT_PhiPhatTatToan}
          ></ChiTietTongSoTienDaTraContainer>
        )}
        {this.state.isShowModalQRThanhToanHD && (
          <ModelQRThanhToanHD
            show={this.state.isShowModalQRThanhToanHD}
            onHide={this.toggleModalQRThanhToanHD.bind(this)}
            hopdong={this.state.itemDataQR}
          />
        )}
      </LayoutV2>
    );
  }
}

BanHangTraGop.propTypes = {
  getList: PropTypes.func,
};

export default BanHangTraGop;
